import { tw } from './zh_tw'
import { en } from './us_en'
import { cn } from './zh_cn'

export const locales = {
  tw: tw,
  en: en,
  cn: cn
}
